import { Link } from 'react-router-dom';
import { WifiOff, Calendar } from 'lucide-react';

export default function OfflineUnavailablePage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-12 h-12 rounded-full bg-yellow-50 flex items-center justify-center mb-4">
          <WifiOff className="w-6 h-6 text-yellow-600" />
        </div>
        <h1 className="text-lg font-semibold text-gray-900">Not available offline</h1>
        <p className="mt-2 text-sm text-gray-600">
          This page needs a connection. The calendar, cached patient charts,
          and clinical documentation remain available; everything syncs when
          connection returns.
        </p>
        <Link
          to="/appointments/calendar"
          className="mt-6 inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md bg-primary text-white hover:opacity-90"
        >
          <Calendar className="w-4 h-4" />
          Go to calendar
        </Link>
      </div>
    </div>
  );
}
